
import commonButton from '@/components/Bargain/buyer/commonButton'
import pzGoodsInfo from '@/components/Bargain/pz-goods-info'
export default {
	components: {
		commonButton,
		pzGoodsInfo
	},
	props: {
		/**
		 * item 数据
		 */
		item: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		/**
		 * 请联系客服继续交易文案
		 */
		showContactServiceText() {
			return this.item.status === 'SUCCESS' && this.item.bargainOrderPayStatus === 'PAID'
		},
		/**
		 * 商品置灰
		 * 已下架、已出售
		 */
		goodsDisabled() {
			return ['ITEM_REMOVED', 'ITEM_SOLD'].includes(this.item.substatus)
		}
	},
	data() {
		return {
			bargainStatusList: []
		}
	},
	methods: {
		onGetTagStatus(data) {
			this.bargainStatusList = data
		},
		/**
		 * 刷新页面
		 */
		onReload() {
			this.$emit('onReload')
		}
	}
}
